// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { RiArrowRightSLine } from 'react-icons/ri';
import './index.scss';
import IconMyCollection from '../../../../assets/imgs/purchaseDetail/iconMyCollection.png';

const TButton = ({ className, disabled = false, title, type, onClick, id, icon = false }) => (
  <button
    type={type}
    className={`btn ol-btn ${className}`}
    disabled={disabled}
    onClick={onClick}
    id={id}
  >
    {icon && (
      <div
        className="my-next-arrow"
        style={{
          background: `url(${IconMyCollection}) no-repeat`,
          backgroundSize: 'contain',
        }}
        onClick={onClick}
      />
    )}
    <span id="btn-text">{title}</span>
    {className.includes('tertiary') && <RiArrowRightSLine />}
  </button>
);

export default TButton;
